import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'
import { getDateIso } from '../Core/Helpers/dateTime'

import { Types } from './actions'

export const INITIAL_STATE = Immutable({
  chatStartTime: null,
  windowIsActive: true,
  windowIsMinimized: false,
})

const launchChat = (state) =>
  state.merge({ windowIsActive: true, windowIsMinimized: false, chatStartTime: getDateIso() })

const setChatStartTime = (state, action) => state.merge({ chatStartTime: action.chatStartTime || getDateIso() })

const toggleActive = (state, action) => state.merge({ windowIsActive: action.windowIsActive, windowIsMinimized: false })

const toggleMinimized = (state, action) => state.merge({ windowIsMinimized: action.windowIsMinimized })

const ACTION_HANDLERS = {
  [Types.LAUNCH_CHAT]: launchChat,
  [Types.SET_CHAT_START_TIME]: setChatStartTime,
  [Types.TOGGLE_ACTIVE]: toggleActive,
  [Types.TOGGLE_MINIMIZED]: toggleMinimized,
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
